import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faArrowLeft, faRobot, faGhost, faSearch } from '@fortawesome/free-solid-svg-icons';
import botImage from "../../assets/images/bot.png";

const NotFound = () => {
  return (
    <div className="not-found-wrapper">
      <div className="blobs">
        <div className="blob one"></div>
        <div className="blob two"></div>
        <div className="blob three"></div>
      </div>

      <motion.div
        className="not-found-card"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="visual-section">
          <motion.div
            className="bot-container"
            animate={{ y: [0, -20, 0] }}
            transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
          >
            <img src={botImage} alt="Rafiq" className="not-found-bot" />
            <div>
              <FontAwesomeIcon icon={faSearch} />
            </div>
          </motion.div>
          <h1 className="error-code">404</h1>
        </div>

        <div className="text-section">
          <h2>أوه! يبدو أننا ضللنا الطريق</h2>
          <p>
            حاولنا بكل جهدنا، لكن "رفيق" لم يجد الصفحة التي تبحث عنها.
            ربما تم نقلها أو أنها لم تكن موجودة من الأساس!
          </p>
        </div>

        <div className="actions">
          <Link to="/" className="home-btn">
            <FontAwesomeIcon icon={faHome} />
            العودة للرئيسية
          </Link>
          <button className="back-btn" onClick={() => window.history.back()}>
            <FontAwesomeIcon icon={faArrowLeft} />
            الرجوع للخلف
          </button>
        </div>
      </motion.div>

      <style jsx>{`
        .not-found-wrapper {
          min-height: 100vh;
          background: #f0f2f5;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          position: relative;
          overflow: hidden;
            font-family: "Zain", sans-serif;
          direction: rtl;
        }

        .blobs .blob {
          position: absolute;
          filter: blur(80px);
          z-index: 1;
          opacity: 0.5;
        }

        .blob.one {
          width: 400px;
          height: 400px;
          background: #7c3aed;
          top: -100px;
          left: -100px;
        }

        .blob.two {
          width: 300px;
          height: 300px;
          background: #ffd60a;
          bottom: -50px;
          right: -50px;
        }

        .blob.three {
          width: 250px;
          height: 250px;
          background: #3b82f6;
          top: 40%;
          left: 60%;
        }

        .not-found-card {
          position: relative;
          z-index: 2;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          padding: 60px 40px;
          border-radius: 40px;
          box-shadow: 0 25px 50px rgba(0,0,0,0.1);
          text-align: center;
          max-width: 600px;
          width: 100%;
        }

        .visual-section {
          position: relative;
          margin-bottom: 40px;
        }

        .bot-container {
          position: relative;
          width: 150px;
          height: 150px;
          margin: 0 auto;
        }

        .not-found-bot {
          width: 100%;
          height: 100%;
          object-fit: contain;
          filter: drop-shadow(0 10px 15px rgba(0,0,0,0.1));
        }

        .search-icon-float {
          position: absolute;
          top: -10px;
          right: -10px;
          background: #fff;
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #7c3aed;
          font-size: 20px;
          box-shadow: 0 5px 15px rgba(0,0,0,0.1);
        }

        .error-code {
          font-size: 120px;
          font-weight: 900;
          margin: 20px 0 0;
          line-height: 1;
          background: linear-gradient(135deg, #7c3aed, #3b82f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          opacity: 0.15;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: -1;
        }

        .text-section h2 {
          font-size: 32px;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 15px;
        }

        .text-section p {
          font-size: 18px;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 40px;
        }

        .actions {
          display: flex;
          gap: 15px;
          justify-content: center;
        }

        .home-btn, .back-btn {
          padding: 14px 28px;
          border-radius: 15px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 10px;
          transition: all 0.3s;
          text-decoration: none;
            font-family: "Zain", sans-serif;
          border: none;
        }

        .home-btn {
          background: #7c3aed;
          color: #fff;
        }

        .home-btn:hover {
          background: #6d28d9;
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(124, 58, 237, 0.2);
        }

        .back-btn {
          background: #fff;
          border: 2px solid #e2e8f0;
          color: #64748b;
        }

        .back-btn:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          color: #1e293b;
        }

        @media (max-width: 480px) {
          .not-found-card {
            padding: 40px 20px;
          }
          .text-section h2 {
            font-size: 24px;
          }
          .actions {
            flex-direction: column;
          }
          .error-code {
            font-size: 80px;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;